import PropTypes from 'prop-types';
import React from 'react';
import { themr } from 'react-css-themr';
import { FontIcon } from 'react-toolbox';

import styles from './search.scss';

class Search extends React.Component {
  state = { value: this.props.value };

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.props.value) {
      this.setState({ value: newProps.value });
    }
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  }

  onSubmit = (e) => {
    this.props.onSubmit(e, this.state.value);
  }

  render() {
    const { theme, placeholder } = this.props;
    return (<form className={theme.wrapper} onSubmit={this.onSubmit}>
      <input
        type="search"
        className={theme.inputElement}
        name="query"
        value={this.state.value || ''}
        onChange={this.onChange}
        placeholder={placeholder}
      />
      <button type="submit" className={theme.submit}>
        <FontIcon className={theme.icon}>search</FontIcon>
      </button>
    </form>);
  }
}

Search.propTypes = {
  theme: PropTypes.shape({
    wrapper: PropTypes.string,
    inputElement: PropTypes.string,
    icon: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default themr('SearchBox', styles)(Search);



// WEBPACK FOOTER //
// ./client/app/shared/components/SearchBox/index.jsx